import { render, staticRenderFns } from "./Highscore.vue?vue&type=template&id=04046050&"
import script from "./Highscore.vue?vue&type=script&lang=js&"
export * from "./Highscore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports